import { ErrorBoundary, Header, Navbar } from "@components/index";
import { Grid, Layout, Space } from "antd";
import { Navigate, useLocation, useOutlet } from "react-router-dom";
import { useEffect, useState } from "react";

import styles from "./Layout.module.scss";
import { useAuth } from "@hooks/useAuth";

const { useBreakpoint } = Grid;
const { Content, Sider } = Layout;
export const ProtectedLayout = () => {
  const outlet = useOutlet();
  const location = useLocation();
  const { md, lg, sm } = useBreakpoint();
  const [height, setHeight] = useState(0);
  const isKnowledgehub = location.pathname === '/knowledgehub';

  useEffect(() => {


    setHeight(window.innerHeight - (isKnowledgehub ? 0 : 93));

    window.addEventListener("resize", () => {
      setHeight(window.innerHeight - (isKnowledgehub ? 0 : 93));
    });
  }, []);

  // if (!user || !user.token) {
  //   return <Navigate to="/auth/login" replace state={{ location }} />;
  // }

  const collapsed = !(md && lg);

  return (
    <Layout>
      <Space className="app-layout" direction="vertical" size="middle" style={{ gap: 0 }}>
        {
           !isKnowledgehub && <Header />
        }
        
        <Layout>
          <ErrorBoundary>
            <Content
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                backgroundColor: "#F9FBFD",
                height,
                width: "100%",
                paddingInline: 0,
              }}
              id="app-layout-content"
            >
              {outlet}
            </Content>
          </ErrorBoundary>
        </Layout>
      </Space>
    </Layout>
  );
};
